import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import GamemasterManager from '../views/GamemasterManager.vue';
import GamemasterExplorer from '../views/GamemasterExplorer.vue';
import ChallongeTest from '../views/ChallongeTest.vue';
import AuthenticationHub from '../views/AuthenticationHub.vue';
import ClientCredentialsManager from '../views/ClientCredentialsManager.vue';
import OAuthCallback from '../views/OAuthCallback.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/gamemaster',
    name: 'GamemasterManager',
    component: GamemasterManager
  },
  {
    path: '/gamemaster-explorer',
    name: 'GamemasterExplorer',
    component: GamemasterExplorer
  },
  {
    path: '/challonge-test',
    name: 'ChallongeTest',
    component: ChallongeTest
  },
  {
    path: '/auth',
    name: 'AuthenticationHub',
    component: AuthenticationHub
  },
  {
    path: '/client-credentials',
    name: 'ClientCredentialsManager',
    component: ClientCredentialsManager
  },
  {
    path: '/oauth/callback',
    name: 'OAuthCallback',
    component: OAuthCallback
  },
  // Legacy redirects for backwards compatibility
  {
    path: '/api-key-manager',
    redirect: '/auth'
  },
  {
    path: '/settings',
    redirect: '/auth'
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
